import Common from '../Common'

const Schedule = class extends Common {
	read = (scheduleId: id): CustomResponse<CalenderSchedule> =>
		this.get(`/schedule/${scheduleId}`)

	deleteAtTimestampWithScheduleIdOnly = (scheduleId: id) =>
		this.doDelete(`/schedule/${scheduleId}/at-timestamp`)
}

export default Schedule
